import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "", once = true, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.2 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
